/**
 * HomePage - product homepage / post-authentication landing point.
 *
 * Forwards to the dashboard's default project. The route (/home,
 * PRODUCT_HOME_PATH) stays unchanged, so all post-auth redirects continue to
 * work without modification.
 *
 * Note: this component must NOT navigate to PRODUCT_HOME_PATH ('/home') itself,
 * as that is the route it is mounted on — doing so would loop. It forwards
 * onward to the dashboard instead, preserving the query string and hash.
 */
import { Navigate, useLocation } from 'react-router-dom';
import { PRODUCT_LANDING_PATH } from '../../utils/authRedirect';

export function HomePage() {
  const { search, hash } = useLocation();
  return (
    <Navigate to={{ pathname: PRODUCT_LANDING_PATH, search, hash }} replace />
  );
}
